import React from 'react';
import { ReviewQuestionModel } from "./ReviewQuestionModel";

type Props = {
    model: ReviewQuestionModel,
    notifyFunc: () => void
}

const ReviewQuestion = (props: Props) => {

    let q = props.model;
    let tpl = props.model.question;
    let notify = props.notifyFunc;

    return (
    <div className="mb-3">
            { tpl.questionText }

            <br/><br/>

            <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio"
                       id={ 'r1' + tpl.id }
                       name={ 'r' + tpl.id }
                       checked={ q.passed === true }
                       onChange={ () => { q.passed = true; notify() }}
                />
                    <label className="form-check-label" htmlFor={ 'r1' + tpl.id }>
                        { tpl.passOptionText }
                    </label>
            </div>
            <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio"
                       id={ 'r2' + tpl.id }
                       name={ 'r' + tpl.id }
                       checked={ q.passed === false }
                       onChange={ () => { q.passed = false; notify() }}
                />
                    <label className="form-check-label" htmlFor={ 'r2' + tpl.id }>
                        { tpl.failOptionText }
                    </label>
            </div>
    </div>);

};

export default ReviewQuestion;
